// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5789a5b6","453":"289bf06a","732":"14924f5e","977":"e7af5ef9"}[chunkId] + ".chunk.js";
};